import Vue from "vue"
import Vuex from "vuex"
import modules from "./modules"
// import _ from 'lodash'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    ...modules
  },
  state: {
    token: null
  },
  getters: {
    isLoggedIn: (state) => !!state.token
  },
  mutations: {
    setToken(state, payload) {
      state.token = payload || ""

      if (payload) {
        const tokenBlob = payload && payload.split(".")

        if (tokenBlob.length >= 2) {
          const userProps = JSON.parse(atob(tokenBlob[1]))
          state.user.profile = { ...userProps }
          // console.log(userProps);
        }

        sessionStorage.setItem("token", payload)
        return
      }

      sessionStorage.removeItem("token")
    }
  },
  actions: {}
})
